import { Accordion, Box, Heading, Label, LabeledControl, Switch } from '@zillow/constellation-10';

import accessUtils from '../../utils/accessUtils';

import type { TagPropsInterface } from '@zillow/constellation-10';

type AccordionContentContainerProps = {
  content: React.ReactNode;
  header?: React.ReactNode;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  tag?: React.ReactElement<TagPropsInterface> | null | undefined;
  id?: string | null;
  eventId?: string;
  accordionIndex: number;
  isFeed?: boolean;
};
/*
 * NOTE: This component is to be used with `Accordion.Root` from `@zillow/constellation-10`
 */
const AccordionContentContainer = ({
  content,
  header = '',
  headingLevel = 3,
  tag = null,
  id = null,
  eventId,
  accordionIndex,
  isFeed = false,
}: AccordionContentContainerProps) => {
  const showFeedOverrideSwitch = isFeed && accessUtils.canAccessFeedOverrides();

  return (
    <Accordion.Item
      value={accordionIndex.toString()}
      id={id ?? undefined}
      data-eventid={eventId}
      data-accordion-index={accordionIndex}
    >
      <Accordion.Header>
        <Heading level={headingLevel} textStyle="heading-xs">
          {header}
        </Heading>
        {tag}
      </Accordion.Header>
      <Accordion.Panel>
        {showFeedOverrideSwitch && (
          <Box css={{ marginBottom: '600', paddingBottom: '400' }}>
            <LabeledControl
              label={<Label>Enable feed overrides</Label>}
              labelPosition="left"
              control={<Switch defaultChecked={false} onChange={() => {}} />}
              css={{ marginBottom: '0' }}
            />
          </Box>
        )}
        {content}
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default AccordionContentContainer;
